import { TFunction } from "i18next";

interface OutcomeSelectionPanelProps {
  selectedAction: string | null;
  outcomes: string[];
  // PMA-COCK-147: renamed from `isSubmitting` -- an ack-latency "syncing"
  // state must never disable these buttons (that silently swallows a
  // legitimate tap); only a genuine lock (cockpitLocked) may.
  disabled: boolean;
  onOutcomeSelect: (outcome: string) => void;
  onCancel: () => void;
  t: TFunction<"logger">;
}

const OutcomeSelectionPanel = ({
  selectedAction,
  outcomes,
  disabled,
  onOutcomeSelect,
  onCancel,
  t,
}: OutcomeSelectionPanelProps) => (
  <div className="bg-white rounded-lg shadow p-6">
    <h2 className="text-lg font-semibold mb-4">
      {t("selectOutcome")} - {selectedAction}
    </h2>
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {outcomes.map((outcome, idx) => (
        <button
          key={outcome}
          onClick={() => onOutcomeSelect(outcome)}
          disabled={disabled}
          data-testid={`outcome-btn-${outcome}`}
          className={`py-4 rounded-lg font-medium transition-colors ${
            disabled
              ? "bg-green-300 text-white cursor-not-allowed"
              : "bg-green-600 hover:bg-green-700 text-white"
          }`}
        >
          {/* PMA-COCK-175: PenaltyKick's Scored/Missed buttons use their own
              outcomePenaltyScored/outcomePenaltyMissed labels ("Anotado" /
              "Fallido") instead of the generic outcome${outcome} key — every
              other action keeps the untouched generic lookup. */}
          {t(
            selectedAction === "PenaltyKick"
              ? `outcomePenalty${outcome}`
              : `outcome${outcome}`,
          )}
          <span className="block text-xs opacity-60 font-mono mt-1">
            [{idx + 1}]
          </span>
        </button>
      ))}
      <button
        onClick={onCancel}
        className="py-4 bg-gray-300 hover:bg-gray-400 text-gray-700 rounded-lg font-medium transition-colors"
      >
        {t("cancel")}
      </button>
    </div>
  </div>
);

export default OutcomeSelectionPanel;
